/**
 * Downloads a file from a (typically presigned) URL into the browser, forcing a download via an anchor with
 * the `download` attribute. The filename is built from a base prefix + index + the extension inferred from
 * the URL.
 */
export async function downloadAttachmentFromUrl(
  url: string,
  index: number,
  filenamePrefix = "archivo",
): Promise<void> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const blob = await res.blob();
  const pathWithoutQuery = url.split("?")[0];
  const extMatch = pathWithoutQuery.match(/\.(pdf|png|jpe?g|gif|webp)$/i);
  const ext = extMatch?.[1] ?? "bin";
  const filename = `${filenamePrefix}-${index + 1}.${ext}`;
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(objectUrl);
}
